import { render, staticRenderFns } from "./parametri.vue?vue&type=template&id=29f3f350&"
import script from "./parametri.vue.ts?vue&type=script&lang=ts&"
export * from "./parametri.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports